//@dependencies
import { put, call } from "redux-saga/effects";
//local imports
import { Actions } from "../../constants/actionTypes";
import { getStore } from "../../../Utils/storeUtils";
import { apiRequest } from "../../../Utils/axiosApi";

export function* createOrg(orgInfo) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/create",
      method: "POST",
      data: orgInfo,
      validateStatus: function (status) {
        return true; // Resolve only if the status code is less than 500
      },
    });

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* fetchAllOrgs() {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/allOrgs",
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_ALL_ORGS, data: result.data });
    } else {
      yield put({ type: Actions.SET_ALL_ORGS, data: null });
    }
  } catch (err) {}
}

export function* apiFetchUserDashboard() {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/dashboardOrgs",
      method: "GET",
    });

    if (result?.isApiSuccessful) {
      yield put({
        type: Actions.SET_ORG_DASHBOARD,
        data: { data: result.data, isApiSuccessful: true },
      });
    } else {
      yield put({
        type: Actions.SET_ORG_DASHBOARD,
        data: { isApiSuccessful: false },
      });
    }
  } catch (err) {
    yield put({
      type: Actions.SET_ORG_DASHBOARD,
      data: { isApiSuccessful: false },
    });
  }
}

export function* fetchUserOrgs() {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/allOrgs/user",
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_USER_ORGS,
        data: { data: result.data, isApiSuccessful: true },
      });
    } else {
      yield put({
        type: Actions.SET_USER_ORGS,
        data: { isApiSuccessful: false },
      });
    }
  } catch (err) {
    yield put({
      type: Actions.SET_USER_ORGS,
      data: { isApiSuccessful: false },
    });
  }
}

export function* apiIsValidOrgName(orgName) {
  try {
    const result = yield call(apiRequest, {
      url: `/organizations/isValidOrgName?orgName=${orgName}`,
      method: "GET",
    });
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* getOrganizationByName(orgName) {
  try {
    const result = yield call(apiRequest, {
      url: `/organizations/getByName/${orgName}`,
      method: "GET",
    });
    return result;
  } catch (err) {
    console.error("Error in getOrganizationByName:", err);
    return { isApiSuccessful: false, data: err };
  }
}

export function* fetchOrgById(orgId) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/" + orgId,
      method: "GET",
    });
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* changeOrgName(org, orgNewName) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/updateOrgName",
      method: "PUT",
      data: {
        orgName: orgNewName,
        orgId: org.orgId,
      },
    });

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* changeOrgOwner(org, orgNewOwner) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/changeOwner",
      data: {
        orgId: org.orgId,
        newOwnerEmailId: orgNewOwner,
      },
      method: "PUT",
    });

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* deleteOrg(org) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/delete/" + org.orgId,
      method: "DELETE",
    });

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* changeOrgMemberRole(org, member, newRole) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/updateMemberRole",
      data: {
        orgId: org.orgId,
        memberEmailId: member.emailId,
        roleId: newRole,
      },
      method: "PUT",
    });

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* inviteUsers(users, org, domain) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/inviteUsers",
      method: "POST",
      data: {
        orgId: org.orgId,
        members: users.map((user) => {
          return {
            roleId: user.roleId,
            memberEmailId: user.emailId,
          };
        }),
        domain: domain,
      },
    });
    if (result.status >= 200 && result.status < 300) {
      return { isApiSuccessful: true, data: result };
    } else if (result.status === 406) {
      return { isApiSuccessful: false, data: result };
    } else {
      return { isApiSuccessful: false, data: result };
    }
  } catch (err) {}
}

export function* bulkUsers(invitedUsers, org, domain) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/inviteUsers",
      method: "POST",
      data: {
        orgId: org.orgId,
        members: invitedUsers,
        domain: domain,
      },
    });
    return result;
  } catch (err) {}
}

export function* deleteMemberFromOrg(org, member) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/" + org.orgId + "/deleteMember/" + member.emailId,
      method: "DELETE",
    });

    if (result.status >= 200 && result.status < 300) {
      return { isApiSuccessful: true, data: result };
    } else {
      return { isApiSuccessful: false, data: result };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* getOrgActivities(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/Activity/orgActivities?orgId=${action.data?.orgId}&size=50&type=${action.data?.type}&startDate=${action.data?.startDate}&endDate=${action.data?.endDate}`,
      method: "GET",
    });

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

// individual space activity api

export function* userActivities(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/Activity/userActivities?size=50&type=${action.data.type}&startDate=${action.data.startDate}&endDate=${action.data.endDate}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({
        type: Actions.PERSONAL_USER_ACTIVITIES,
        activities: { ...result.data, isApiSuccessful: result.isApiSuccessful },
      });
    } else {
      yield put({
        type: Actions.PERSONAL_USER_ACTIVITIES,
        activities: { isApiSuccessful: result.isApiSuccessful, actions: null },
      });
    }
  } catch (err) {
    yield put({
      type: Actions.PERSONAL_USER_ACTIVITIES,
      activities: { isApiSuccessful: false, actions: null },
    });
  }
}

export function* apiSelectedOrg(orgId) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/" + orgId,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_SELECTED_ORG,
        data: result.data,
      });
    } else {
      yield put({
        type: Actions.SET_SELECTED_ORG,
        data: null,
      });
    }

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

// graph details

export function* timelineGraphDetails(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/dashboard/timePeriodGraphData?type=${action.data.type}&orgId=${action.data.orgId}&startDate=${action.data.startDate}&endDate=${action.data.endDate}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_TIMELINEGRAPH_DETAILS,
        data: result.data,
      });

      return result;
    } else {
      action?.meta?.onError();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action?.meta?.onError();
    yield put({
      type: Actions.SET_SELECTED_ORG,
      data: null,
    });

    return { isApiSuccessful: false, data: err };
  }
}

export async function apiFetchChildOrgs(orgName) {
  try {
    const result = await apiRequest({
      url: `/organizations/fetchChildOrgDetails?orgName=${orgName}`,
      method: "GET",
    });
    return { isApiSuccessful: true, data: result };
  } catch (err) {
    console.error("Error fetching child organizations:", err);
    return { isApiSuccessful: false, data: err };
  }
}

export async function apiFetchgetChildOrgDetails(orgName) {
  try {
    const result = await apiRequest({
      url: `/organizations/getRequestMembers?orgName=${orgName}`,
      method: "GET",
    });
    return { isApiSuccessful: true, data: result };
  } catch (err) {
    console.error("Error fetching child organizations:", err);
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiOrgImage(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/organizations/orgImageUpload`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_ORGANIZATION_IMAGE,
        data: result,
      });
      return result;
    } else {
      action.meta.Error();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDeleteImage(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/organizations/deleteOrgImage?orgId=${action.data.orgId}`,
      method: "DELETE",
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess();
      return result;
    } else {
      action.meta.Error();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDelImage(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/removeSiteImage?siteName=${action.data.siteName}`,
      method: "DELETE",
    });
    if (result.isApiSuccessful) {
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export async function apiGetChildOrgOtp(orgId, userId) {
  try {
    const result = await apiRequest({
      url: `/organizations/generateOtpChildOrg?orgId=${orgId}&userId=${userId}`,
      method: "GET",
    });
    return { isApiSuccessful: true, data: result };
  } catch (err) {
    console.error("Error getting OTP:", err);
    return { isApiSuccessful: false, data: err.message };
  }
}

export async function apiValidateChildOrgOtp(orgId, userId, otp) {
  try {
    const result = await apiRequest({
      url: `/organizations/validateOtpChildOrg?orgId=${orgId}&userId=${userId}&otp=${otp}`,
      method: "GET",
    });
    return { isApiSuccessful: true, data: result };
  } catch (err) {
    console.error("Error validating OTP:", err);
    return { isApiSuccessful: false, data: err.message };
  }
}

export async function apiChildOrgCountryChange(data) {
  try {
    const { orgId, ...clientAddressRequest } = data;
    const result = await apiRequest({
      url: `/organizations/childOrg/updateCountry?orgId=${orgId}`,
      method: "POST",
      data: clientAddressRequest,
    });
    return { isApiSuccessful: true, data: result };
  } catch (err) {
    console.error("Error validating OTP:", err);
    return { isApiSuccessful: false, data: err.message };
  }
}

export function* apiFetchChildDetails(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/organizations/selectChildOrgPlan?orgId=${action.data?.orgId}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_CHILD_PLAN_DETAILS,
        data: result.data,
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetOrgAddress(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/organizations/getOrgAddress?orgId=${action.data?.orgId}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_ORG_ADDRESS,
        data: result.data,
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}
